/**
 * Package entry — Dropdown (ACH) content type
 */

import pkgJson from '../package.json';

export const VERSION = pkgJson.version;
export const PKG_NAME = pkgJson.name;

export {
    qtDropdownSchema,
    defaultQtDropdownConfig,
    defaultQtDropdownData,
    defaultQtDropdownI18n,
    normalizeQtDropdownAnswerMap,
    createQtDropdownItem,
    type QtDropdownContent,
    type QtDropdownData,
    type QtDropdownConfig,
    type QtDropdownLayoutConfig,
    type QtDropdownItem,
    type QtDropdownSplitRatio,
} from './schema';

export { normalizeQtDropdownLayoutConfig } from './layout';
export {
    gradeQtDropdown,
    validateQtDropdownContent,
    validateQtDropdownAnswer,
    qtDropdownContentGrader,
    countDropdownQuestions,
    qtDropdownQuestionCounter,
    type QtDropdownItemResult,
} from './scorer';

export { DropdownEdit, type DropdownEditProps } from './DropdownEdit';
export { DropdownPlayer, type DropdownPlayerProps } from './DropdownPlayer';

export { qtDropdownSchema as default } from './schema';
